export default __webpack_public_path__ + "static/media/eye-off.b314115f.svg";